import React, { useEffect, useState, useCallback } from "react";
import "./DarkMode.css";

// Move constants outside to avoid unnecessary re-renders
const clickedClass = "clicked";
const lightTheme = "light";
const darkTheme = "dark";

const DarkMode = () => {
  const [theme, setTheme] = useState(null);

  // Memoize handleSystemThemeChange so it can safely be a dependency
  const handleSystemThemeChange = useCallback((e) => {
    const newTheme = e.matches ? darkTheme : lightTheme;
    if (!localStorage.getItem("theme")) {
      document.body.classList.remove(darkTheme, lightTheme);
      document.body.classList.add(newTheme);
      setTheme(newTheme);
    }
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    // Define helper inside useEffect to satisfy dependency rules
    const getSystemThemePreference = () => {
      return mediaQuery.matches ? darkTheme : lightTheme;
    };

    mediaQuery.addEventListener("change", handleSystemThemeChange);

    const savedTheme = localStorage.getItem("theme");
    const initialTheme = savedTheme || getSystemThemePreference();

    document.body.classList.remove(lightTheme, darkTheme);
    document.body.classList.add(initialTheme);
    setTheme(initialTheme);

    return () =>
      mediaQuery.removeEventListener("change", handleSystemThemeChange);
  }, [handleSystemThemeChange]); // handleSystemThemeChange is now a stable dependency

  const switchTheme = (e) => {
    const newTheme = theme === darkTheme ? lightTheme : darkTheme;

    document.body.classList.remove(lightTheme, darkTheme);
    document.body.classList.add(newTheme);

    if (newTheme === darkTheme) {
      e.target.classList.add(clickedClass);
    } else {
      e.target.classList.remove(clickedClass);
    }

    localStorage.setItem("theme", newTheme);
    setTheme(newTheme);
  };

  if (theme === null) return null;

  return (
    <div>
      <div
        className={theme === darkTheme ? clickedClass : ""}
        id="darkMode"
        onClick={(e) => switchTheme(e)}
      >
        <span>
          <i className="fas fa-sun"></i>
        </span>
        <span>
          <i className="fas fa-moon"></i>
        </span>
      </div>
    </div>
  );
};

export default DarkMode;
